<div *ngIf="isLoading">
	Loading General Demographics
	<mat-icon>
		<mat-spinner diameter="18"> </mat-spinner>
	</mat-icon>
</div>

<div *ngIf="!isLoading">
	<div><b>Gender:</b> {{student.SEX}}
	</div>
	<div><b>Race:</b> {{student.RACE}}</div>
	<div><b>DOB:</b> {{student.DOB! | simpleDate}} {{student.DOB! | cleanDate | age}}</div>
	<div>
		<b>Birth Place:</b>
		<span *ngIf="birthAddress.CITy?.ID">
			{{birthAddress.CITy?.CITY_NAME | titlecase}}
			<span *ngIf="birthAddress.CITy?.STATE?.STATE_CODE?.length == 0">{{birthAddress.CITy?.STATE?.STATE_NAME |
				titlecase}}</span>{{birthAddress.CITy?.STATE?.STATE_CODE}},
			{{birthAddress.CITy?.STATE?.COUNTRy?.COUNTRY_NAME | titlecase}}
		</span>
		<span *ngIf="!birthAddress.CITy?.ID">---</span>
	</div>
	<div><b>Birth Verification:</b> {{student.BIRTH_VERIFY}}</div>
	<div><b>Medical Alert:</b> {{student.HEALTH_NOTE}}</div>
	<div class="margin-top-sm">
		<span class="padding-horizontal-xs" matTooltipClass="multiline-tooltip">
			<mat-icon class="v-align-middle" [color]="student.LATINO === 'Y' ? 'primary' : ''">
				{{student.LATINO === 'Y' ? 'check_box' :
				'check_box_outline_blank'}}
			</mat-icon>
			Latino
		</span>
		<span class="padding-horizontal-xs" matTooltipClass="multiline-tooltip">
			<mat-icon class="v-align-middle" [color]="student.HEALTH_NOTE === 'Y' ? 'primary' : ''">
				{{student.HEALTH_NOTE === 'Y' ? 'check_box' :
				'check_box_outline_blank'}}
			</mat-icon>
			Health Note
		</span>
		<span class="padding-horizontal-xs" matTooltipClass="multiline-tooltip">
			<mat-icon class="v-align-middle" [color]="student.MULTI_BIRTH === 'Y' ? 'primary' : ''">
				{{student.MULTI_BIRTH === 'Y' ? 'check_box' :
				'check_box_outline_blank'}}
			</mat-icon>
			Multi Birth
		</span>
	</div>
</div>